export const FlagBadge = ({ flag, name, className = "" }) => {
  if (!flag) return null;
  return (
    <img
      src={flag}
      alt={name ? `Drapeau ${name}` : "Drapeau de nationalité"}
      title={name || ""}
      loading="lazy"
      data-testid="nationality-flag"
      className={`flag-wave pointer-events-none absolute -right-[12%] top-[6%] z-10 h-3.5 w-6 rounded-[2px] object-cover shadow-md ring-1 ring-black/40 ${className}`}
    />
  );
};

export default FlagBadge;
